import { CONFIG_OPTION_TOAST_ERROR, CONFIG_OPTION_TOAST_NORMAL } from 'common/toast';
import DropdownOption from 'components/Common/DropdownOption';
import LabelWrapper from 'components/Common/LabelWrapper';
import { useFormik } from 'formik';
import { AI_MODEL_BOOSTING_NEWS_TRAVEL_OPTIONS, SYSTEM_CONFIG_KEY } from 'helpers/constans';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { Col, Input, Label, Modal, ModalBody, ModalHeader, Row, Spinner } from 'reactstrap';
import { getConfiguration, postGenerateNewsTravel } from 'store/thunks';
import * as Yup from "yup";

interface ModalGenerateNewsTravelProps {
    isOpen: boolean;
    onRefresh?: () => void,
    onClose?: () => void,
}

const ModalGenerateNewsTravel: React.FC<ModalGenerateNewsTravelProps> = ({
    isOpen, onRefresh, onClose
}) => {
    const { t } = useTranslation();

    const AI_MODEL_NEWS_TRAVEL_OPTIONS_LANG: any = AI_MODEL_BOOSTING_NEWS_TRAVEL_OPTIONS?.map((item: any) => ({ value: item?.value, label: t(item?.label) }));

    const NEWS_V2_LOG_STATUS: any = {
        INITIAL: 1,
        ERROR: 2,
        COMPLETED: 3,
    };

    const isIntervalRef = useRef<boolean>(false);
    let intervalId: any;

    const [isGenerating, setIsGenerating] = useState<boolean>(false);

    const handleClose = () => {
        onClose && onClose();
        formik.setValues({
            ai_model: AI_MODEL_NEWS_TRAVEL_OPTIONS_LANG[0],
            prompt: '',
            title: '',
            include_weather: 0,
        });
        formik.setErrors({});
    }

    // Update: correct according to available thunk
    const handleSubmit = async (values: any) => {
        try {
            if (isGenerating) return;
            setIsGenerating(true);
            const request = {
                ai_model: values?.ai_model?.value || '',
                // prompt: values?.prompt || '',
                title: values?.title || '',
                include_weather: Number(values?.include_weather) || 0,
            };
            const response: any = await postGenerateNewsTravel(request);
            setIsGenerating((_prev) => false);
            if (response?.code === 200) {
                toast(`${t('The process has been completed.')}`, CONFIG_OPTION_TOAST_NORMAL);
                onRefresh && onRefresh();
            } else {
                toast(`${response || ""}`, CONFIG_OPTION_TOAST_ERROR);
            }

        } catch (error: any) {
            setIsGenerating((_prev) => false);
            toast(`${error?.message || ''}`, CONFIG_OPTION_TOAST_ERROR);
            return error;
        }
    };

    const validationSchema = Yup.object({
        prompt: Yup.string().required(`${t("This is required")}`),
        title: Yup.string().nullable(),
        include_weather: Yup.number().nullable(),
    });

    const formik = useFormik({
        initialValues: {
            ai_model: AI_MODEL_NEWS_TRAVEL_OPTIONS_LANG[0],
            prompt: '',
            title: '',
            include_weather: 0,
        },
        validationSchema: validationSchema,
        onSubmit: handleSubmit,
        enableReinitialize: true,
    });

    const handleCallAllOption = async () => {
        try {
            const [res1]: any = await Promise.all([getConfiguration()]);
            const _configs = res1?.data?.list || [];
            const _ai_model = _configs?.find((item: any) => item?.key === SYSTEM_CONFIG_KEY.TRAVEL_NEWS_GENERATE_AI_MODEL)?.value || '';
            const _generate_prompt = _configs?.find((item: any) => item?.key === SYSTEM_CONFIG_KEY.TRAVEL_NEWS_GENERATE_PROMPT)?.value || '';
            formik.setFieldValue('prompt', _generate_prompt);
            formik.setFieldValue('ai_model', AI_MODEL_NEWS_TRAVEL_OPTIONS_LANG?.find((item: any) => item?.value === _ai_model) || AI_MODEL_NEWS_TRAVEL_OPTIONS_LANG[0]);
        } catch (error) {
            return error;
        }
    };

    useEffect(() => {
        if (isOpen) {
            handleCallAllOption();
        }
    }, [isOpen]);

    return (
        <>
            <Modal
                isOpen={isOpen}
                centered={true}
                size="md"
                scrollable={false}
            >
                <ModalHeader toggle={handleClose}>
                    <>{t("Generate Travel News")}</>
                </ModalHeader>
                <ModalBody className="pt-2">
                    <form onSubmit={formik.handleSubmit}>
                        <div>
                            <div className="card-body mt-0 pb-1">
                                <Row>
                                    {/* <Col sm={12} md={12} className='mt-3 mt-md-0 mb-3'>
                                        <LabelWrapper label={t('Generate Prompt')} isShow={true}>
                                            <Input
                                                name="prompt"
                                                type="textarea"
                                                className="form-control mb-3 mb-lg-2 mb-xxl-1"
                                                placeholder=""
                                                style={{ height: '200px' }}
                                                value={formik?.values?.prompt}
                                                onChange={formik.handleChange}
                                                autoComplete="off"
                                                disabled={isGenerating}
                                            />
                                            <div className="w-100 mb-1 mb-xl-0 fs-12 text-muted pt-0">
                                                {t(`{{keywords}} will replace dynamically`, { keywords: `{chat_history_block}, {search_query}, {current_date}, {weather_info}, {places_data_json}` })}
                                            </div>
                                            {formik.errors.prompt && formik.touched.prompt && (
                                                <div className="text-danger">{formik.errors.prompt}</div>
                                            )}
                                        </LabelWrapper>
                                    </Col> */}
                                    <Col sm={6} md={6} lg={6} xl={6} xxl={6} className='mt-3 mb-1'>
                                        <LabelWrapper label={t('AI Model')} isShow={true}>
                                            <DropdownOption
                                                name="ai_model"
                                                dataList={AI_MODEL_NEWS_TRAVEL_OPTIONS_LANG || []}
                                                placeholder={`${t("AI Model")}...`}
                                                className={`dropdown-status-rounded z-hight mb-3 mb-lg-2 mb-xxl-1`}
                                                classNamePrefix="name-prefix"
                                                initialValue={formik?.values?.ai_model}
                                                onChangeSelect={(e: any) => {
                                                    formik.setFieldValue('ai_model', e);
                                                }}
                                            />
                                        </LabelWrapper>
                                    </Col>
                                    <Col sm={12} md={12} lg={12} xl={12} xxl={12} className='mt-3'>
                                        <LabelWrapper label={t('Title') + ` (${t("Keyword")})`} isRequired={false} isShow={true}>
                                            <Input
                                                name="title"
                                                type="text"
                                                className={`form-control mb-3 mb-lg-2 mb-xxl-1`}
                                                placeholder=""
                                                value={formik?.values?.title}
                                                style={{ width: '100%', minWidth: '100px' }}
                                                onChange={formik.handleChange}
                                                autoComplete="off"
                                            />
                                            {formik.errors.title && formik.touched.title && (
                                                <div className="text-danger">{formik.errors.title}</div>
                                            )}
                                        </LabelWrapper>
                                    </Col>
                                    <Col sm={12} md={12} lg={12} xl={12} xxl={12} className='mt-3 mb-0'>
                                        <div className="form-check form-switch mb-0">
                                            <Input className="form-check-input"
                                                type="checkbox"
                                                role="switch"
                                                id={`include_weather`}
                                                name={`include_weather`}
                                                checked={!!formik?.values?.include_weather}
                                                onChange={(event: any) => {
                                                    formik.setFieldValue(`include_weather`, Number(event?.target.checked))
                                                }}
                                            />
                                            <Label htmlFor={`include_weather`} className={`form-label mb-0 ${!!formik?.values?.include_weather ? 'text-primary' : 'text-muted'}`}>
                                                {t('Include Weather Info in the news')}
                                            </Label>
                                        </div>
                                    </Col>
                                    <Col sm={12} className='mt-4'>
                                        <div className='w-100 d-flex justify-content-end align-items-center gap-4'>
                                            <button
                                                className="btn btn-primary rounded-pill"
                                                type="submit"
                                                disabled={isGenerating}
                                                style={{ width: '160px' }}
                                            >
                                                {isGenerating ? <span style={{ transform: 'translateY(1px)' }}><Spinner size="sm" /></span> : <></>}
                                                <span className="ms-1">{t("Generate News")}</span>
                                            </button>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    </form>
                </ModalBody>
            </Modal>
        </>
    );
};

export default React.memo(ModalGenerateNewsTravel);

